<div *ngIf="!hide && selectedFilters.length" class="list-selected">
  <ng-container *ngFor="let filter of selectedFilters; let index = index">
    <acl-ngx-chip *ngIf="!filter.isDynamic" [label]="filter.label" [text]="filter.currentSelection"
      [menuItems]="filter.options" (close)="removeFilter(index)">
    </acl-ngx-chip>
    <div *ngIf="filter.isDynamic" class="acl-chip dynamic-list" (mouseenter)="setShowCloseButton(filter, true)"
      (mouseleave)="setShowCloseButton(filter, false)">
      <div class="chip-label-container">
        <span>{{filter.label}}</span>
      </div>
      <span class="chip-text">
        <auto-complete [endpointUrl]="filter.options" width="120px" [limit]="25" [searchProps]="searchProps"
          [initialValue]="filter.currentSelection" (onClickOutside)="handleOnFilterClickOutside($event, filter, index)"
          (onSelect)="handleOnFilterSelect($event, filter)">
        </auto-complete>
      </span>
      <div class="close-chip" *ngIf="filter.showCloseButton">
        <a (click)="removeFilter(index)">
          <acl-ngx-icon [name]="'Remove'"></acl-ngx-icon>
        </a>
      </div>
    </div>
  </ng-container>
</div>